import * as React from 'react';
import prefixes from './PrefixManager';
import './sizingbreakpoints.scss';
export var Container = function (props) {
    function getClassName() {
        var classNames = [props.fluid ? 'container-fluid' : 'container'];
        if (props.className) {
            classNames.push(props.className);
        }
        return "" + prefixes.container + classNames.join(' ');
    }
    return React.createElement("div", { className: getClassName() }, props.children);
};
//# sourceMappingURL=Container.js.map